import {FC} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ITagGroup} from 'modules/products/types';
import {TagList} from 'modules/products/components/TagList';
import capitalize from 'lodash/capitalize';

interface IProps {
    tagGroups: ITagGroup[];
}

export const ProductDetailedTagGroups: FC<IProps> = ({tagGroups = []}) => {
    return (
        <>
            {/* <Typography className={style.title} element={'h2'} variant={'h3-medium'}>*/}
            {/*    Теги*/}
            {/* </Typography>*/}
            <div className={style.tagsWrapper}>
                {tagGroups.map(({title, code, tags}) => {
                    if (!tags.length) {
                        return null;
                    }

                    return (
                        <div className={style.rowWrapper} key={code}>
                            <Typography className={style.rowTitle} data-skeleton-item={true} variant={'label-16-m'}>
                                {capitalize(title)}
                            </Typography>
                            {/* <TagList tags={Array.from({length: 2}).flatMap(() => tags)} groupCode={code} />*/}
                            <TagList tags={tags} groupCode={code} />
                        </div>
                    );
                })}
            </div>
        </>
    );
};
